import { render, staticRenderFns } from "./NoteItem.vue?vue&type=template&id=fa007118&"
import script from "./NoteItem.vue?vue&type=script&lang=js&"
export * from "./NoteItem.vue?vue&type=script&lang=js&"
import style0 from "./NoteItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports